import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { AnimationStyleDisplay } from './styles/AnimationStyleDisplay';
import { AnimationStyleMove } from './styles/AnimationStyleMove';

const animationTimelong = '400ms';
const animationTimeMedium = '300ms';
const animationTimeShort = '200ms';

// Routable animations
export const flyInOut = trigger('flyInOut', [
   transition(
      'inactive => active',
      animate(
         `${animationTimelong} ease-out`,
         keyframes([
            AnimationStyleDisplay.noOpacity,
            AnimationStyleMove.rightPosition,
            AnimationStyleDisplay.fullOpacity,
            AnimationStyleMove.twistRight,
            AnimationStyleMove.twistLeftLight,
            AnimationStyleMove.twistRightVeryLight,
            AnimationStyleMove.displayPosition,
         ])
      )
   ),
   transition(
      'active => removed',
      animate(
         `${animationTimeShort} ease-out`,
         keyframes([
            AnimationStyleDisplay.fullOpacity,
            AnimationStyleMove.displayPosition,
            AnimationStyleMove.twistBottom,
            AnimationStyleMove.bottomPosition,
            AnimationStyleDisplay.noOpacity,
         ])
      )
   ),
]);

export const toggleDisable = trigger('toggleDisable', [
   state('btn-disabled', style({ opacity: '{{opacity}}', color: '{{color}}', background: '{{background}}' }), {
      params: { opacity: 0.3, color: '#ffffff', background: '#000000' },
   }),
   state('btn-enabled', style({})),
   transition('btn-enabled => btn-disabled', [animate('0.25s ease-in')]),
   transition('btn-disabled => btn-enabled', [animate('0.25s ease-out')]),
]);

export const fadeIntoExistance = trigger('fadeIntoExistance', [
   state(
      'closed',
      style({
         visibility: 'hidden',
         opacity: 0,
         height: '0px',
         width: '0px',
      })
   ),
   state(
      'open',
      style({
         visibility: 'visible',
         opacity: 1,
         height: '{{height}}px',
         width: '{{width}}px',
      }),
      { params: { height: 800, width: 600 } }
   ),
   transition('closed => open', animate('0.3s ease-out')),
]);

export const windowHideShow = trigger('windowHideShow', [
   state(
      'window-hidden',
      style({
         visibility: 'hidden',
         opacity: 0,
         top: '70px',
         left: '-170px',
         height: '0px',
         width: '0px',
      })
   ),
   state(
      'window-shown',
      style({
         visibility: 'visible',
         opacity: 1,
         top: '{{top}}px',
         left: '{{left}}px',
         height: '{{height}}px',
         width: '{{width}}px',
      }),
      { params: { top: 100, left: 100, height: 800, width: 600 } }
   ),
   transition('window-shown => window-hidden', [animate('0.3s')]),
   transition('window-hidden => window-shown', [animate('0.3s')]),
]);

export const displayHide = trigger('displayHide', [
   state('show', style({ display: '{{display}}', opacity: '{{opacity}}' }), { params: { display: 'flex', opacity: 1 } }),
   state('hide', style({ display: 'none', opacity: 0 })),
   transition('hide => show', animate(`${animationTimeMedium} ease`)),
   transition('show => hide', animate(`${animationTimeMedium} ease`)),
]);

export const moveInAndOut = trigger('moveInAndOut', [
   transition(
      'right => show',
      animate(
         `${animationTimelong} ease-out`,
         keyframes([
            AnimationStyleDisplay.noOpacity,
            AnimationStyleMove.rightPosition,
            AnimationStyleDisplay.fullOpacity,
            AnimationStyleMove.twistRight,
            AnimationStyleMove.twistLeftLight,
            AnimationStyleMove.twistRightVeryLight,
            AnimationStyleMove.displayPosition,
         ])
      )
   ),
   transition(
      'show => right',
      animate(
         `${animationTimeShort} ease-out`,
         keyframes([
            AnimationStyleDisplay.fullOpacity,
            AnimationStyleMove.displayPosition,
            AnimationStyleMove.twistLeft,
            AnimationStyleMove.rightPosition,
            AnimationStyleDisplay.noOpacity,
         ])
      )
   ),
   transition(
      'left => show',
      animate(
         `${animationTimelong} ease-out`,
         keyframes([
            AnimationStyleDisplay.noOpacity,
            AnimationStyleMove.leftPosition,
            AnimationStyleDisplay.fullOpacity,
            AnimationStyleMove.twistLeft,
            AnimationStyleMove.twistRightLight,
            AnimationStyleMove.twistLeftVeryLight,
            AnimationStyleMove.displayPosition,
         ])
      )
   ),
   transition(
      'show => left',
      animate(
         `${animationTimeShort} ease-out`,
         keyframes([
            AnimationStyleDisplay.fullOpacity,
            AnimationStyleMove.displayPosition,
            AnimationStyleMove.twistRight,
            AnimationStyleMove.leftPosition,
            AnimationStyleDisplay.noOpacity,
         ])
      )
   ),
   transition(
      'top => show',
      animate(
         `${animationTimelong} ease-out`,
         keyframes([
            AnimationStyleDisplay.noOpacity,
            AnimationStyleMove.topPosition,
            AnimationStyleDisplay.fullOpacity,
            AnimationStyleMove.twistBottom,
            AnimationStyleMove.twistTopLight,
            AnimationStyleMove.twistBottomVeryLight,
            AnimationStyleMove.displayPosition,
         ])
      )
   ),
   transition(
      'show => top',
      animate(
         `${animationTimeShort} ease-out`,
         keyframes([
            AnimationStyleDisplay.fullOpacity,
            AnimationStyleMove.displayPosition,
            AnimationStyleMove.twistTop,
            AnimationStyleMove.topPosition,
            AnimationStyleDisplay.noOpacity,
         ])
      )
   ),
   transition(
      'bottom => show',
      animate(
         `${animationTimelong} ease-out`,
         keyframes([
            AnimationStyleDisplay.noOpacity,
            AnimationStyleMove.bottomPosition,
            AnimationStyleDisplay.fullOpacity,
            AnimationStyleMove.twistTop,
            AnimationStyleMove.twistBottomLight,
            AnimationStyleMove.twistTopVeryLight,
            AnimationStyleMove.displayPosition,
         ])
      )
   ),
   transition(
      'show => bottom',
      animate(
         `${animationTimeShort} ease-out`,
         keyframes([
            AnimationStyleDisplay.fullOpacity,
            AnimationStyleMove.displayPosition,
            AnimationStyleMove.twistBottom,
            AnimationStyleMove.bottomPosition,
            AnimationStyleDisplay.noOpacity,
         ])
      )
   ),
]);
